"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.findOption = findOption;
exports.findOptions = findOptions;
exports.flattenOptions = flattenOptions;
exports.isLeveledOption = isLeveledOption;
exports.isLeveledNode = isLeveledNode;
/** Finds first option by Key, and returns it + any parents. */
function findOption(options, key, getOptionValue) {
    // This is technically an array of "maybe FoundOption"
    const todo = options.map((option) => ({ option, parents: [] }));
    while (todo.length > 0) {
        const curr = todo.pop();
        if (getOptionValue(curr.option) === key) {
            return curr;
        }
        else if (curr.option.children) {
            // Search our children and pass along us as the parent
            todo.push(...curr.option.children.map((option) => ({ option, parents: [...curr.parents, curr.option] })));
        }
    }
    return undefined;
}
/** Finds all options by Key, and returns it + any parents. */
function findOptions(options, key, getOptionValue) {
    // This is technically an array of "maybe FoundOption"
    const todo = options.map((option) => ({ option, parents: [] }));
    const found = [];
    while (todo.length > 0) {
        const curr = todo.pop();
        if (getOptionValue(curr.option) === key) {
            found.push(curr);
        }
        else if (curr.option.children) {
            // Search our children and pass along us as the parent
            todo.push(...curr.option.children.map((option) => ({ option, parents: [...curr.parents, curr.option] })));
        }
    }
    return found;
}
function flattenOptions(o) {
    var _a;
    return [o, ...(((_a = o.children) === null || _a === void 0 ? void 0 : _a.length) ? o.children.flatMap((oc) => flattenOptions(oc)) : [])];
}
function isLeveledOption(option) {
    return Array.isArray(option) && option.length === 2 && typeof option[1] === "number";
}
function isLeveledNode(node) {
    return isLeveledOption(node.value);
}
